import React from 'react';
import styled from 'styled-components';
import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';
import radioIcon from 'utils/icon/radio_button_off.png';
import radioSelectIcon from 'utils/icon/radio_button_on.png';
/**
 * * 서버 체크 라디오 버튼
 */

const ServerRadio = () => {
  const location = useLocation();
  const [cookies, setCookie] = useCookies();
  // isUpdate가 undefined이 아니면 라디오 버튼이 비활성화 된다.
  const pathlocation = location.pathname.split('/');
  const isUpdate = `${pathlocation[2]}`;

  const handleServerClick = (e) => {
    setCookie('server', e.target.value);
  };

  return (
    <StyledRadio>
      {cookies.server === 'server' && (
        <div className='caution'>
          ** 현재 표시되는 데이터는 ** <br />
          ** 라이브서버의 데이터입니다. **
        </div>
      )}
      <input
        onChange={handleServerClick}
        type='radio'
        name='server'
        id='test'
        value='test'
        checked={cookies.server === 'test' ? true : false}
        disabled={isUpdate !== 'undefined' && true}
      />
      <label htmlFor='test'>
        <span></span>테스트
      </label>

      <input
        onChange={handleServerClick}
        type='radio'
        name='server'
        id='ifyou'
        value='server'
        checked={cookies.server === 'server' ? true : false}
        disabled={isUpdate !== 'undefined' && true}
      />
      <label htmlFor='ifyou'>
        <span></span>라이브(IF YOU)
      </label>
    </StyledRadio>
  );
};

export default ServerRadio;

const StyledRadio = styled.div`
  text-align: right;
  position: relative;
  margin-right: 0.5rem;
  display: flex;
  align-items: center;

  input[type='radio'] {
    display: none;
  }
  span {
    margin: 0 6px 1px 0;
  }
  input[type='radio'] + label {
    margin-right: 15px;
  }
  input[type='radio'] + label span {
    display: inline-block;
    width: 15px;
    height: 16px;
    /* margin: -10px 10px 0 0; */
    vertical-align: middle;
    background: url(${radioIcon}) left top no-repeat;
    cursor: pointer;
    background-size: contain;
  }
  input[type='radio']:checked + label span {
    background: url(${radioSelectIcon}) left top no-repeat;
    display: inline-block;
    width: 15px;
    height: 16px;
    /* margin: -10px 10px 0 0; */
    vertical-align: middle;
    background-size: contain;
  }

  .caution {
    color: red;
    font-size: 0.8rem;
    text-align: center;
    line-height: 1rem;
    font-weight: 700;
    margin-right: 1rem;
  }
`;
